import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-pdf-modal-view',
  templateUrl: './pdf-modal-view.component.html',
  styleUrls: ['./pdf-modal-view.component.scss']
})
export class PdfModalViewComponent implements OnInit {
  loading: any = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public thisDialog: MatDialogRef<PdfModalViewComponent>) { }

  ngOnInit() {
  }


}



// WEBPACK FOOTER //
// ./src/app/main/content/common/pdf-modal-view/pdf-modal-view.component.ts